import React, { useState, useEffect } from "react";
import Banner from "../../common/components/banner";
import Utils from "../../utility";
import PropTypes from "prop-types";
const EmailVerificationComponent = (props) => {
  const { sendVerificationMail, counter, resendEnabled, handleClickHere } =
    props;
  const [componentHeight, setComponentHeight] = useState(window.innerHeight);

  const updateComponentHeight = () => {
    setComponentHeight(window.innerHeight);
  };

  useEffect(() => {
    updateComponentHeight();
    window.addEventListener("resize", updateComponentHeight);
    return () => {
      window.removeEventListener("resize", updateComponentHeight);
    };
  }, []);

  return (
    <div
      className="flex lg:overflow-hidden "
      style={{ height: componentHeight }}
    >
      <div className="flex w-full flex-col overflow-y-auto bg-white px-5 md:w-1/2 ">
        <div className="flex pl-2 pt-3">
          <img alt="logo" className="z-10" src="/images/datasent-logo.svg" />
        </div>
        <div className="my-auto w-full pb-4 md:mx-auto md:max-w-97">
          <img src="/images/email.svg" alt="Email Icon" />
          <div className="mt-49px flex font-MontserratSemiBold text-ft20-24.38-0.4 ">
            A verification link has been sent to your email account
          </div>
          <div className="mt-5 flex font-Montserrat text-ft15 tracking-tighter">
            Please click on the link that has just been sent to your email and
            continue the registration process.
          </div>
          <button
            className={`${
              !resendEnabled && "opacity-50"
            } mt-9.5 h-12 w-87 rounded bg-purple-6C36B0 font-Montserrat text-ft15 text-white`}
            onClick={sendVerificationMail}
            disabled={!resendEnabled}
          >
            Send Email Again
          </button>
          <div className="flex gap-1 ">
            <span className={`${resendEnabled && "hidden"}`}>
              Resend in 00:{Utils.formatCounter(counter)}
            </span>
          </div>
          <p className="mt-9.5 font-MontserratRegular text-ft15 text-black-20">
            Email already verified
            <span
              onClick={handleClickHere}
              className="cursor-pointer font-MontserratRegular text-ft15 text-blue-726FFF"
            >
              &nbsp; Click Here
            </span>
          </p>
        </div>
      </div>
      <Banner />
    </div>
  );
};
EmailVerificationComponent.propTypes = {
  sendVerificationMail: PropTypes.func.isRequired,
  counter: PropTypes.number.isRequired,
  resendEnabled: PropTypes.bool.isRequired,
  handleClickHere: PropTypes.func.isRequired
};
export default EmailVerificationComponent;
